import { FileUpload } from 'components/ui/forms/field/awesomeFileInput/types'
import { MultimediaTypes } from 'enum/multimediaTypes.enum'
import { multimediaBlockIframeAllowedFiles } from 'helpers/allowedExtensionFiles.helper'
import { getExtensionOnly } from 'helpers/validators.helper'
import { useMemo } from 'react'

export const useAskCanDownload = (files: FileUpload[]) => {
  const showAllowDownload = useMemo(
    () =>
      files.some(({ name }) => {
        const filename = name
        const extension = filename && getExtensionOnly(filename)

        const fileType =
          (extension &&
            multimediaBlockIframeAllowedFiles.find((allowedFile) =>
              allowedFile.extension.includes(extension.toLowerCase())
            )) ||
          null

        const type = fileType?.type

        return (
          type && [MultimediaTypes.pdf, MultimediaTypes.video].includes(type)
        )
      }),
    [files]
  )

  return showAllowDownload
}
